// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JLRB","colBig":"styles_colBig__1F5xF","colSmall":"styles_colSmall__bdfcB"};